export default {
  pageTitle: '投诉中心',
  reportingHistory: '投诉历史',
  newReport: '新增投诉',
  complaintInfo: '投诉信息',
  type: '类型',
  status: '状态',
  operation: '操作',
  viewDetails: '查看详情',
  search: '搜索',
  allTypes: '全部类型',
  allStatus: '全部状态',
  startTime: '开始时间',
  endTime: '结束时间',
  INFRINGEMENT: '侵权',
  PENDING: '审核中',
  APPROVED: '已通过',
  REJECTED: '未通过',
  productUrl: '商品链接',
  productUrlPlaceholder: '粘贴商品链接',
  reportingType: '投诉类型',
  description: '投诉原因',
  descriptionPlaceholder: '请详细描述违规情况',
  uploadCertificate: '上传证明材料',
  uploadTip: '点击上传证明材料（JPG/PNG/PDF）',
  submit: '提交',
  reportingRecords: '投诉记录',
  complaintId: '投诉 ID',
  createTime: '创建时间',
  reportingTypeLabel: '投诉类型',
  productUrlLabel: '商品链接',
  descriptionLabel: '投诉原因',
  rejectionReasonLabel: '拒绝原因',
  adminRemarkLabel: '备注',
  INSUFFICIENT_CERTIFICATES: '提交的证明材料不充分',
  /** 与运营后台枚举 CERTIFICATES_NOT_AUTHENTIC 对齐 */
  CERTIFICATES_NOT_AUTHENTIC: '提交的证明材料不真实',
  NOT_AUTHENTIC: '提交的证明材料不真实',
  certificateLabel: '上传证明材料',
  certificateFile: '文件附件/图片',
  submitSuccess: '投诉提交成功',
  submitFail: '投诉提交失败',
  fieldRequired: '此项为必填项',
  urlInvalid: '请输入有效的商品链接'
}
